import { useReducer } from "react";

const initialState = [];

const reducer = (state, action) => {
  const numberOfPromptLines = state.filter((r) => r.type === "prompt").length;
  const numberOfOutputLines = state.filter((r) => r.type === "output").length;
  switch (action.type) {
    case "prompt":
      return [...state, { title: `Prompt ${numberOfPromptLines + 1}`, type: "prompt", content: action.payload.prompt }];
    case "textChunk":
      const existing = state.find((r) => r.type === "output" && r.index === action.payload.index && r.inferenceBlockCount === action.payload.inferenceBlockCount);
      if (!existing) {
        return [
          ...state,
          {
            title: `Output ${numberOfOutputLines + 1}`,
            type: "output",
            content: action.payload.text,
            index: action.payload.index,
            inferenceBlockCount: action.payload.inferenceBlockCount,
            isForEndUser: action.payload.isForEndUser,
          },
        ];
      } else {
        existing.content += action.payload.text;
        return [...state];
      }
    case "reset":
      return initialState;
    case "error":
      return [...state, { type: "error", content: action.payload.message }];
    default:
      return state;
  }
};

export const useTestResultReducer = () => useReducer(reducer, initialState);
